exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width:686px){.newsletter-action__content__step[data-v-8971a1f4]{width:362px}.newsletter-action__content__padding-correction[data-v-8971a1f4]{padding:0 75px}.newsletter-action__container[data-v-8971a1f4]{right:-685px}.newsletter-action__container--extended[data-v-8971a1f4]{right:-512px}}h2[data-v-8971a1f4]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8971a1f4","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/site/components/newsletter-widget/tour-intro-slide.vue
// module id = xpXB
// module chunks = 0